import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { getFleetMaintenanceTypes } from '../../../services/fleetService';
import { apiParamsState } from '../../../storage/app';
import {
  fleetMaintenanceTypesFiltersState,
  fleetMaintenanceTypesReloadListState,
} from '../../../storage/fleetMaintenanceTypes';

function useFleetMaintenanceTypes() {
  const apiParams = useRecoilValue(apiParamsState);
  const [filters, setFilters] = useRecoilState(fleetMaintenanceTypesFiltersState);
  const [reload, setReload] = useRecoilState(fleetMaintenanceTypesReloadListState);
  const resetAllFilters = useResetRecoilState(fleetMaintenanceTypesFiltersState);

  const resetFilters = () => {
    setFilters((prev) => ({
      ...prev,
      ownedByMe: false,
    }));
  };

  const onReload = () => {
    setReload((prev) => !prev);
  };

  const onChangeFilter = (filterName: keyof typeof filters, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  const loadFleetMaintenanceTypes = async () => {
    if (!apiParams)
      return {
        types: undefined,
        error: 'Selecciona un espacio de trabajo.',
        total: undefined,
      };
    const { types, error, total } = await getFleetMaintenanceTypes({
      page: filters.page,
      clientId: apiParams.clientId,
      subClientId: apiParams.subClientId,
      search: filters.search,
    });
    return {
      types,
      error,
      total,
    };
  };

  return {
    loadFleetMaintenanceTypes,
    onReload,
    reload,
    resetAllFilters,
    resetFilters,
    page: filters.page,
    onChangePage: (page: number) => {
      onChangeFilter('page', page);
    },
    search: filters.search,
    onChangeSearch: (search: string) => {
      onChangeFilter('search', search);
    },
  };
}

export default useFleetMaintenanceTypes;
